import classNames from 'classnames';
import React from 'react';
import { CleanDeliveryOrder } from '../../../../export-types/cleaned-types';
import { useOutletContext } from 'react-router-dom';
import { OutletContextParams } from '../delivery-orders-screen';

type Props = {
  data: CleanDeliveryOrder;
};

export const MarkAsReceivedCheckbox = ({ data }: Props) => {
  const {
    selectedOrders,
    onChangeSelectedOrders,
    selectAllOrders,
    setSelectAllOrders,
  } = useOutletContext<OutletContextParams>();
  const onToggle = () => {
    const id = data.internalId;
    const existedOrderIndex = selectedOrders.findIndex(
      (order) => order.internalId === id,
    );
    if (existedOrderIndex !== -1) {
      const newOrders = [...selectedOrders];
      newOrders.splice(existedOrderIndex, 1);
      onChangeSelectedOrders(newOrders);
    } else {
      onChangeSelectedOrders([...selectedOrders, data]);
    }
  };

  return (
    <input
      className={classNames('form-check-input p-2 border-2 cursor-pointer')}
      type="checkbox"
      checked={
        selectedOrders.findIndex(
          (order) => order.internalId === data.internalId,
        ) !== -1 || selectAllOrders
      }
      onChange={() => {
        if (
          selectedOrders.findIndex(
            (order) => order.internalId === data.internalId,
          ) !== -1
        ) {
          setSelectAllOrders(false);
        }
        onToggle();
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    />
  );
};
